import {navigateTo, useTranslation} from '#imports';
import type {MaltIllustrationName} from '@malt/nuxt-joy-module/types/malt-illustration-name';
import type {TJoyButtonVariants} from '@maltjoy/core-vue';

export interface ProjectStateProps {
    illustrationName: MaltIllustrationName;
    imgWidth?: string;
    imgHeight?: string;
    title: string;
    subtitle: string;
    projectStateCTA?: {redirect: () => void; variant: TJoyButtonVariants; label: string};
}

export function useProjectStateProps() {
    const {t} = useTranslation();

    async function brpSubmissionRedirect() {
        await navigateTo('/business-referral/submission?source=my-referrals', {
            open: {
                target: '_blank',
            },
        });
    }

    const projectStateProps = new Map<string, ProjectStateProps>()
        .set('EMPTY', {
            illustrationName: 'safe-box--high',
            imgWidth: '188',
            imgHeight: '206',
            title: t('business-referral.table.empty.title'),
            subtitle: t('business-referral.table.empty.subtitle'),
            projectStateCTA: {
                redirect: brpSubmissionRedirect,
                variant: 'primary',
                label: t('business-referral.table.empty.cta'),
            },
        })
        .set('APPROVED', {
            illustrationName: 'paper-signature--high',
            imgWidth: '145',
            title: t('business-referral.details.status.approved.title'),
            subtitle: t('business-referral.details.status.approved.description'),
        })
        .set('CANCELLED', {
            illustrationName: 'plug-unplugged--high',
            imgWidth: '240',
            title: t('business-referral.details.status.canceled.title'),
            subtitle: t('business-referral.details.status.canceled.description'),
        })
        .set('STAFFING_IN_PROGRESS', {
            illustrationName: 'binoculars--high',
            imgWidth: '145',
            title: t('business-referral.details.status.staffing.title'),
            subtitle: t('business-referral.details.status.staffing.description'),
        });

    function getProjectStateProps(state: string) {
        return projectStateProps.get(state);
    }

    return {getProjectStateProps, brpSubmissionRedirect};
}
